import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toLower from 'lodash/toLower';
import PropTypes from 'prop-types';
// Core components
import IconSelect from 'components/core/IconSelect';
// Custom
import { countryShape } from 'constants/PropTypesShapes';
import { FlagImg } from 'components/img/AssetImg';

const CountrySelector = ({
  countries, value, onChange, disabled,
}) => (
  <IconSelect
    value={value}
    disabled={disabled}
    items={
      _map(countries, ({ code, label }) => (
        {
          key: code,
          value: code,
          label: <div className="ml-2">{label || <LocalizedMessage id={`country.${_toLower(code)}`} />}</div>,
          icon: <FlagImg width={25} countryCode={code} />,
        }
      ))
    }
    onChange={onChange}
  />
);

CountrySelector.propTypes = {
  countries: PropTypes.arrayOf(countryShape),
  countriesScope: PropTypes.oneOf(['all', 'known']).isRequired, // eslint-disable-line react/no-unused-prop-types
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CountrySelector.defaultProps = {
  countries: null,
  disabled: false,
};

const mapStateToProps = (state, ownProps) => ({
  countries: state.country[ownProps.countriesScope],
});

module.exports = connect(
  mapStateToProps,
  null,
)(CountrySelector);



// WEBPACK FOOTER //
// ./components/inputFields/CountrySelector.js